import {
  MatchedRevenueAndConversionBreakdown,
  RevenueAndConversionBreakdown,
  ExtrapolatedRevenueAndConversionBreakdown,
} from './FunnelBreakdown';
import { FacebookTargetingSpec } from '../facebook';

export enum BreakdownLevel {
  Campaign = 'campaign',
  Adset = 'adset',
  Ad = 'ad',
}

export interface BusinessFunnelTableBreakdown {
  campaignName: string;
  campaign_id: string;
  campaignStart?: string;
  campaignEnd?: string;
  id?: string;
  campaignID?: string;
  adsetName?: string;
  adset_id?: string;
  adset_targetingSpec?: FacebookTargetingSpec;
  adName?: string;
  ad_id?: string;
  page_id?: string;
  story_id?: string;
  conversions: number;
  revenue?: number;
  spend: number;
  impressions: number;
  costPer: number;
  roas?: number;
  adPreview?: string;
  clickThroughRate?: number;
  clicks?: number;
}

export interface FunnelStageSourceBreakdown {
  attributed: RevenueAndConversionBreakdown;
  extrapolated: ExtrapolatedRevenueAndConversionBreakdown;
  matched: MatchedRevenueAndConversionBreakdown;
}
